import {createTheme, ThemeOptions} from "@mui/material";
import {colorAlabaster, DEFAULT_THEME_OPTIONS} from "../shared/colors";

export const COLOR_PRIMARY = "#000066";
export const COLOR_SECONDARY = "#ff6600";

const HEADING_FONT = "Plus Jakarta Sans, sans-serif";
const BODY_FONT = "Inter, sans-serif";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    ...DEFAULT_THEME_OPTIONS.typography,
    h1: {
      fontWeight: "bold",
      letterSpacing: -1.3,
      fontFamily: HEADING_FONT,
    },
    h2: {
      fontWeight: "bold",
      letterSpacing: -1.2,
      fontFamily: HEADING_FONT,
    },
    h3: {
      fontWeight: "bold",
      letterSpacing: -1.1,
      fontFamily: HEADING_FONT,
    },
    h4: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h5: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h6: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    fontFamily: BODY_FONT,
    fontSize: 14,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#fff",
    },
  }
};

export const THEME = createTheme(THEME_OPTIONS);
